export default __webpack_public_path__ + "minus-sign-inside-a-black-circle.png";